module.exports = __webpack_public_path__ + "img/activity5.c5c3beb7.jpg";